import React from "react";
import Layouts from "./layout/Layout";
import { Route, Routes } from "react-router-dom";
import OTP from "./pages/NotAuth/OTP";
import Asset from "./pages/NotAuth/Asset";
import LiffBasic from "./pages/NotAuth/LiffBasic";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import LoadingMain from './components/dialog/LoadingMain'

const theme = createTheme({
  typography: {
    fontFamily: `'Kittithada Roman 55', 'Kanit', sans-serif`,
    fontSize: 16,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});

function App() {

  return (
    <>
     <ThemeProvider theme={theme}>
          <Layouts>
            <LoadingMain/>
            <Routes>
              <Route path="/otp" element={<OTP />} />
              <Route path="/liff-basic" element={<LiffBasic />} />
              <Route path="/asset" element={<Asset />} />
            </Routes>
          </Layouts>
        </ThemeProvider>
    </>
  );
}

export default App;
